import { FC } from "react";
import * as React from "react";
import { useDropdownContext } from "../dropdown-context";

export type DropdownLabelProps = React.HTMLProps<HTMLLabelElement>;

export const DropdownLabel: FC<DropdownLabelProps> = ({
  children,
  ...rest
}) => {
  const { getLabelProps } = useDropdownContext();

  if (!getLabelProps) {
    throw new Error(
      "Dropdown.Label component requires getLabelProps to be defined",
    );
  }

  return <label {...getLabelProps({ ...rest })}>{children}</label>;
};

export default DropdownLabel;
